const selectors = {
  corpForm: "[data-corporative-form]",
  corpForm: "[data-corporative-form]",
  formSubmitButton: "[data-form-button]",
  formBottomMessage: "[data-form-message]",
  dateSelector: "[data-form-date-select]",
  regionsSelect: "[data-region-select]",
  comunesSelect: "[data-comune-select]",
};
const corpForm = document.querySelector(selectors.corpForm);
const regionsSelect = document.querySelector(selectors.regionsSelect);
const comunesSelect = document.querySelector(selectors.comunesSelect);
const dateSelector = document.querySelector(selectors.dateSelector);
const formSubButton = document.querySelector(selectors.formSubmitButton);
const formessage = document.querySelector(selectors.formBottomMessage);
const regiones = arrayRegions;

//cargar regiones
chargeSelects(regionsSelect, regiones, true);

dateSelector.addEventListener("change", function () {
  dateSelector.classList.remove("select_placeholder");
});

//cargar comunas en base a las regiones de chile
regionsSelect.addEventListener("change", function () {
  comunesSelect.innerHTML = "";
  regionsSelect.classList.remove("select_placeholder");
  comunesSelect.classList.remove("select_placeholder");
  const selectedRegion = regionsSelect.selectedIndex - 1;
  const regionComunes = regiones[selectedRegion].cities;
  chargeSelects(comunesSelect, regionComunes);
  createSubmitAction();
});

//carga de options en los select, sease de comuna, regiones
function chargeSelects(item, locations, regionSelect) {
  //recibe como parametros, el contenedor, el array de regiones, y un boolean que indica si trabajará con regiones, estados o comunas
  locations.forEach((singleLocation) => {
    var locationName = document.createElement("option");
    if (regionSelect === true) {
      locationName.textContent = singleLocation.name;
      locationName.value = singleLocation.name;
    } else {
      locationName.textContent = singleLocation;
      locationName.value = singleLocation;
    }
    // locationName.value = singleLocation.name;
    item.appendChild(locationName);
  });
}

comunesSelect.addEventListener("change", function () {
  createSubmitAction();
});

function createSubmitAction() {
  const formRegion = regionsSelect.value;
  const formComune = comunesSelect.value;
  console.log(formRegion);
  console.log(formComune);
}

corpForm.addEventListener("submit", function (event) {
  console.clear();
  event.preventDefault();

  formValidation();

  function formValidation() {
    const allInputs = corpForm.querySelectorAll("input");
    const allTextarea = corpForm.querySelectorAll("textarea");
    const allSelects = corpForm.querySelectorAll("select");
    const allFields = [...allInputs].concat([...allTextarea, ...allSelects]);
    var validateForm = true;

    allFields.forEach((inputItem) => {
      if (inputItem.value === "") {
        validateForm = false;
      }
    });

    if (validateForm === true) {
      formSubButton.innerHTML = "Enviando...";
      formSubButton.disabled = true;
      formessage.classList.add("hide");
      const sendData = new FormData(corpForm);

      fetch("https://merken-api.custom.cl/vesperpro-form", {
        method: "POST",
        body: sendData,
      })
        .then(() => {
          formessage.classList.remove("hide");
          formessage.classList.add("send-form");
          formessage.innerHTML =
            "<span>¡Formulario enviado exitosamente!</span>Te contactaremos a la brevedad";
          formSubButton.classList.add("send-form");
          formSubButton.innerHTML = "¡Envío exitoso!";
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      formessage.innerHTML = "Faltan campos en el formulario";
    }
  }
});
